export const STRING={
    layer:"Slot"
}